<template>
  <nav class="bottom-nav">
    <router-link
      v-for="item in navItems"
      :key="item.name"
      :to="item.to"
      class="nav-item"
      :class="{ active: isActive(item.to) }"
    >
      <div class="nav-icon"><i :class="item.icon"></i></div>
      <span class="nav-label">{{ item.label }}</span>
      <span v-if="isActive(item.to)" class="nav-pip"></span>
    </router-link>

    <div class="nav-item nav-item--logout" @click="handleLogout">
      <div class="nav-icon"><i class="fas fa-sign-out-alt"></i></div>
      <span class="nav-label">Salir</span>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore();

const navItems = [
  { name: 'home',     to: '/',               icon: 'fas fa-home',          label: 'Inicio'      },
  { name: 'students', to: '/students',        icon: 'fas fa-user-graduate', label: 'Estudiantes' },
  { name: 'recharge', to: '/recharge-select', icon: 'fas fa-credit-card',   label: 'Recargar'    },
  { name: 'settings', to: '/settings',        icon: 'fas fa-cog',           label: 'Perfil'      },
];

const isActive = (path: string) => route.path === path;
const handleLogout = () => store.dispatch('auth/signOff');
</script>

<style>
.bottom-nav {
  display: flex;
  align-items: center;
  height: var(--an-nav-h);
  background: var(--an-white);
  border-top: 1px solid var(--an-gray-100);
  padding: 0 8px;
  box-shadow: 0 -6px 20px rgba(0,0,0,.06);
  z-index: 100;
  flex-shrink: 0;
  width: 100%;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 6px 4px;
  text-decoration: none;
  color: var(--an-gray-400, #9CA3AF);
  transition: color .15s;
}
.nav-item.active { color: var(--an-green); }
.nav-icon { width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
.nav-label { font-family: var(--an-font); font-size: 10px; font-weight: 600; }
.nav-pip { display: block; width: 4px; height: 4px; border-radius: 50%; background: var(--an-green); }

.nav-item--logout {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 6px 4px;
  cursor: pointer;
  color: var(--an-red, #E53935);
}

/* MOBILE: fixed */
@media (max-width: 767px) {
  .bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

/* DESKTOP: static inside flex column */
@media (min-width: 768px) {
  .bottom-nav {
    position: static;
    border-radius: 0 0 36px 36px;
  }
}
</style>
